import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkObjHasAllValue } from "../../../../components/ui_comps/ComissionContainer";
import CustomUploadField from "../../../../components/ui_comps/CustomUploadField";
import RowButton from "../../../../components/ui_comps/RowButton";
function ClientFileUploads({ onClickNext, onClickBack, reduxData }) {
  const [uploadSignedSla, setUploadSignedSla] = useState("");
  const [uploadPan, setUploadPan] = useState("");
  const [uploadGstCerts, setUploadGstCerts] = useState("");
  const [uploadIncorporationCert, setUploadIncorporationCert] = useState("");
  const [uploadNdaCertificates, setUploadNDACertificates] = useState("");
  const [uploadCancelledCheque, setUploadCancelledCheque] = useState("");
  const [uploadKycSignAuth, setUploadKycSignAuth] = useState("");
  const [uploadMemoOfAssocation, setMemoOfAssocation] = useState("");
  const [uploadarticleOfAssocation, setUploadArticleOfAssocation] =
    useState("");
  const [uploadMerchantApprovalForm, setUploadMerchantApprovalForm] =
    useState("");

  const dispatch = useDispatch();

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px",
  };

  const { enqueueSnackbar } = useSnackbar();

  // useEffect(() => {
  //   if (
  //     reduxData?.uploadSignedSla &&
  //     reduxData?.uploadPan &&
  //     reduxData?.uploadGstCerts &&
  //     reduxData?.uploadIncorporationCert &&
  //     reduxData?.uploadNdaCertificates &&
  //     reduxData?.uploadCancelledCheque &&
  //     reduxData?.uploadKycSignAuth &&
  //     reduxData?.uploadMemoOfAssocation &&
  //     reduxData?.uploadarticleOfAssocation &&
  //     reduxData?.uploadMerchantApprovalForm
  //   ) {
  //     setUploadSignedSla(reduxData?.uploadSignedSla);
  //     setUploadPan(reduxData?.uploadPan);
  //     setUploadGstCerts(reduxData?.uploadGstCerts);
  //     setUploadIncorporationCert(reduxData?.uploadIncorporationCert);
  //     setUploadNDACertificates(reduxData?.uploadNdaCertificates);

  //     setUploadCancelledCheque(reduxData?.uploadCancelledCheque);
  //     setUploadKycSignAuth(reduxData?.uploadKycSignAuth);
  //     setMemoOfAssocation(reduxData?.uploadMemoOfAssocation);
  //     setUploadArticleOfAssocation(reduxData?.uploadarticleOfAssocation);
  //     setUploadMerchantApprovalForm(reduxData?.uploadMerchantApprovalForm);
  //   }
  // }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxHeight: 650,
        overflow: "auto",
      }}
    >
      <p
        style={{
          fontSize: 10,
          color: "grey",
          margin: "10px 0px",
          padding: 0,
          margin: 0,
        }}
      >
        Maximum upload file size 2MB.
      </p>

      <p
        style={{
          fontSize: 10,
          color: "grey",
          margin: "10px 0px",
          marginTop: 3,
        }}
      >
        Please upload files only with following extensions [png, jpg, img,
        image, jpeg, pdf].
      </p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          maxHeight: 650,
          overflow: "auto",
        }}
        className="hide-scroll-bar"
      >
        <div>
          <p style={textStyle}>Upload Signed SLA</p>
          <CustomUploadField
            onChange={(data) => setUploadSignedSla(data)}
            onClickRemove={() => {
              setUploadSignedSla("");
            }}
            value={uploadSignedSla}
          />
        </div>
        <div>
          <p style={textStyle}>Upload PAN card</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadPan(data)}
            onClickRemove={() => {
              setUploadPan("");
            }}
          />
        </div>
        <div>
          <p style={textStyle}>Upload GST certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadGstCerts(data)}
            onClickRemove={() => {
              setUploadGstCerts("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Incorporation certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadIncorporationCert(data)}
            onClickRemove={() => {
              setUploadIncorporationCert("");
            }}
          />
        </div>

        <div style={{}}>
          <p style={textStyle}>Upload NDA certificate</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadNDACertificates(data)}
            onClickRemove={() => {
              setUploadNDACertificates("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload cancelled Cheque</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadCancelledCheque(data)}
            onClickRemove={() => {
              setUploadCancelledCheque("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload KYC of the signing authority</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadKycSignAuth(data)}
            onClickRemove={() => {
              setUploadKycSignAuth("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Memorandum of Association</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setMemoOfAssocation(data)}
            onClickRemove={() => {
              setMemoOfAssocation("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Article of Association</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadArticleOfAssocation(data)}
            onClickRemove={() => {
              setUploadArticleOfAssocation("");
            }}
          />
        </div>
        <div style={{}}>
          <p style={textStyle}>Upload Merchant Approval Form</p>
          <CustomUploadField
            //   value={uploadSignedSla}
            onChange={(data) => setUploadMerchantApprovalForm(data)}
            onClickRemove={() => {
              setUploadMerchantApprovalForm("");
            }}
          />
        </div>
      </div>

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          if (
            checkObjHasAllValue({
              uploadSignedSla,
              uploadPan,
              uploadGstCerts,
              uploadIncorporationCert,
              uploadNdaCertificates,
              uploadCancelledCheque,
              uploadKycSignAuth,
              uploadMemoOfAssocation,
              uploadMerchantApprovalForm,
              uploadarticleOfAssocation,
            })
          ) {
            onClickNext({
              uploadSignedSlaUrl: uploadSignedSla,
              panCardUrl: uploadPan,
              gstCertificateUrl: uploadGstCerts,
              incorporationCertificateUrl: uploadIncorporationCert,
              ndaCertificateUrl: uploadNdaCertificates,
              cancelledChequeUrl: uploadCancelledCheque,
              kycSigningAuthorityUrl: uploadKycSignAuth,
              memorandumOfAssociationUrl: uploadMemoOfAssocation,
              articleOfAssociationUrl: uploadarticleOfAssocation,
              merchantApprovalFormUrl: uploadMerchantApprovalForm,
            });
          } else {
            enqueueSnackbar("Please upload all the files", {
              variant: "error",
            });
          }
        }}
      />
    </div>
  );
}

export default ClientFileUploads;
